<template>
  <section class="flex-1">
    <lazy-dom>
      <!--    :rules="checkRefer==1?{}:rules"-->
      <el-form
        ref="form"
        :rules="formRules"
        :model="formData"
      >

        <div class="box">
          <h3>Policy Detail</h3>
          <div class="flex-sb">
            <div class="form-item form-half">
              <span>Expected Effective Date</span>
              <el-form-item
                ref="pcy_cmnt_dt"
                :prop="isCancel?'':'pcy_cmnt_dt'">
                <v-date-picker
                  v-model="formData.pcy_cmnt_dt"
                  :_45daysComfirm='true'
                  :disabled="isCancel||showBuyable"/>
              </el-form-item>
            </div>
            <div class="form-item form-half">
              <span>Expected Expiry Date</span>
              <el-form-item
                ref="pcy_expry_dt"
                prop="pcy_expry_dt">
                <v-date-picker
                  v-model="formData.pcy_expry_dt"
                  :disabled="isCancel||isAdjust&&formData.plan_type==2||showBuyable"/>
              </el-form-item>
            </div>
          </div>
          <!--          <div class="form-item ">-->
          <!--            <span>{{ isEndorsement? 'Endorsement Effective Date': 'Effective Date' }}</span>-->
          <!--            <el-form-item-->
          <!--              v-if="isCancel"-->
          <!--              ref="pcy_expry_dt"-->
          <!--              :prop="checkRefer===1?'':'pcy_expry_dt'">-->
          <!--              <v-date-picker-->
          <!--                v-model="formData.pcy_expry_dt"-->
          <!--                :picker-options="pickerOptions"/>-->
          <!--            </el-form-item>-->
          <!--            &lt;!&ndash;          <el-form-item&ndash;&gt;-->
          <!--            &lt;!&ndash;            v-else&ndash;&gt;-->
          <!--            &lt;!&ndash;            :prop="checkRefer===1?'':'pcy_cmnt_dt'">       &ndash;&gt;-->
          <!--            <el-form-item-->
          <!--              v-else-->
          <!--              ref="pcy_cmnt_dt"-->
          <!--              prop="pcy_cmnt_dt">-->
          <!--              <v-date-picker-->
          <!--                v-model="formData.pcy_cmnt_dt"-->
          <!--                :picker-options="pickerOptions"/>-->
          <!--            </el-form-item>-->
          <!--          </div>-->
          <!--          <div class="form-item">-->
          <!--            <span>Contract Period</span>-->
          <!--            <el-form-item-->
          <!--              ref="contr_prd"-->
          <!--              prop="contr_prd">-->
          <!--              <v-select-->
          <!--                v-model="formData.contr_prd"-->
          <!--                :disabled="isCancel"-->
          <!--                :list="localAllOptions.period" />-->
          <!--            </el-form-item>-->
          <!--          </div>-->
          <div class="form-item">
            <span>Building Age</span>
            <el-form-item
              ref="bldg_age"
              prop="bldg_age">
              <v-select
                v-model="formData.bldg_age"
                :disabled="true"
                :list="localAllOptions.bldg_ages" />
            </el-form-item>
          </div>
          <div class="form-item">
            <span>Total Contract Sum</span>
            <el-form-item
              ref="tol_contr_sum"
              prop="tol_contr_sum">
              <v-input
                v-model="formData.tol_contr_sum"
                :disabled="true"
                append="HK$" />
            </el-form-item>
          </div>
          <div class="form-item">
            <span>Material Damage Coverage</span>
            <el-form-item
              ref="mat_dam_cvr_ind"
              prop="mat_dam_cvr_ind">
              <v-radio-group
                v-model="formData.mat_dam_cvr_ind"
                :border="true"
                :disabled="true"
                :list="yesNoOptions" />
            </el-form-item>
          </div>
          <div class="form-item">
            <span>Third Party Liability Coverage </span>
            <el-form-item
              ref="tp_lia_cvr_ind"
              prop="tp_lia_cvr_ind">
              <v-radio-group
                v-model="formData.tp_lia_cvr_ind"
                :border="true"
                :disabled="true"
                :list="yesNoOptions" />
            </el-form-item>
          </div>

          <div class="form-item">
            <span>Third Party Liability Limit</span>
            <el-form-item
              ref="tppd_limit_amt"
              prop="tppd_limit_amt">
              <!--              :disabled="formData.tp_lia_cvr_ind != 1||isCancel"-->
              <v-select
                v-model="formData.tppd_limit_amt"
                :disabled="true"
                :list="localAllOptions.limit_of_liability" />
            </el-form-item>
          </div>

          <div class="form-item">
            <span>Outdoor Work or Scaffolding Work</span>
            <el-form-item
              ref="outdoor_wk_ind"
              prop="outdoor_wk_ind">
              <v-radio-group
                v-model="formData.outdoor_wk_ind"
                :border="true"
                :list="yesNoOptions"
                :disabled="true" />
            </el-form-item>
          </div>

          <div
            v-if="formData.outdoor_wk_ind == 1"
            class="form-item">
            <span>Total Contract Value of Outdoor Work and/or Scaffolding Work</span>
            <el-form-item
              ref="scaffolding_wk"
              prop="scaffolding_wk">
              <v-select
                v-model="formData.scaffolding_wk"
                :list="localAllOptions.scaffolding_wk"
                :disabled="true"/>
            </el-form-item>
          </div>

          <div class="form-item">
            <span>Employee Compensation</span>
            <el-form-item
              ref="employee_ind"
              prop="employee_ind">
              <v-radio-group
                v-model="formData.employee_ind"
                :border="true"
                :list="yesNoOptions"
                :disabled="true" />
            </el-form-item>
          </div>
        </div>
        <div
          v-if="benefitList.length>0"
          class="box">
          <!--          <h2>Insured Items</h2>-->
          <div
            class="form-item form-half">
            <span>Insured Items</span>
            <el-form-item
            >
              <v-checkbox-group
                v-model="formData.benefits"
                :list="benefitList"
                :disabled="showBuyable"
                :isColumn="false"
                @change="handlerExtra"
              />
            </el-form-item>
          </div>
        </div>
        <div class="box">
          <h3>Policyholder Details</h3>
          <decoration-policy-holder-form
            ref="policy-holder-form"
            :formDataLock="formDataLock"
            :form="formData"
            :disabled="isCancel||showBuyable"
            :checkRefer="checkRefer"
            :isRequired="isRequired"
            @getFormData="getSubFormData"
            @confirm="getConfirmChangeResult" />
        </div>
        <h3>Work Details</h3>
        <span class="title">Location of Works</span>
        <address-form
          ref="work-address-form"
          :formDataLock="formDataLock"
          :form="workAddressData"
          :formType="1"
          :disabled="isCancel||showBuyable"
          :allRequired="false"
          :isRequired="isRequired"
          :not-valid="checkRefer==2?false:true"
          @getFormData="getSubFormData" />

        <div class="form-item">
          <span>Property Type</span>
          <el-form-item
            ref="occupied_as"
            prop="occupied_as">
            <v-select
              v-model="formData.occupied_as"
              :list="localAllOptions.occupied_as"
              :disabled="isCancel||showBuyable" />
          </el-form-item>
        </div>
        <div class="box">
          <!--          <h3>Contractor</h3>-->
          <!--          <div class="form-item">-->
          <!--            <span>Name</span>-->
          <!--            <el-form-item-->
          <!--              ref="con_nm"-->
          <!--              prop="con_nm">-->
          <!--              <v-input-->
          <!--                v-model="formData.con_nm"-->
          <!--                :disabled="isCancel"/>-->
          <!--            </el-form-item>-->
          <!--          </div>-->
          <!--          <div class="form-item">-->
          <!--            <span>Phone Number</span>-->
          <!--            <el-form-item-->
          <!--              ref="con_phone_no"-->
          <!--              prop="con_phone_no">-->
          <!--              <v-input-->
          <!--                v-model="formData.con_phone_no"-->
          <!--                type="number"-->
          <!--                :disabled="isCancel"/>-->
          <!--            </el-form-item>-->
          <!--          </div>-->
          <!--          <span class="title">Correspondence Address</span>-->
          <!--          <address-form-->
          <!--            ref="con-address-form"-->
          <!--            :formDataLock="formDataLock"-->
          <!--            :form="conAddressData"-->
          <!--            :formType="1"-->
          <!--            :disabled="isCancel"-->
          <!--            :not-valid="checkRefer==2?false:true"-->
          <!--            @getFormData="getSubFormData"/>-->
          <span class="title">Sub-Contractor (if any)</span>
          <div class="form-item">
            <span>Sub Contractors</span>
            <v-input
              v-model="formData.sub_contractors"
              :disabled="isCancel||showBuyable ||checkDisabled('sub_contractors')"/>
          </div>
          <div class="form-item">
            <span>Property Management Company</span>
            <v-input
              v-model="formData.property_management_company"
              :disabled="isCancel||showBuyable || checkDisabled('property_management_company')"/>
          </div>
        </div>


        <div class="box">
          <h2>Upload Document</h2>
          <div class="flex-sb">
            <div
              v-if="editType==3"
              class="form-item form-half">
              <span >Renewal Letter（Insurer）</span>
              <el-form-item
                ref="renewal_letter_insurer_path_id"
                prop="renewal_letter_insurer_path_id">
                <v-upload
                  :card="true"
                  ::disabled="isCancel||showBuyable"
                  :fileData="formData.renewal_letter_insurer"
                  :otherData="{
                    target: 'renewal_letter_insurer',
                    idKey: 'renewal_letter_insurer_path_id',
                    nameKey: 'renewal_letter_insurer_path',
                    type:'renewal_letter_insurer_path'
                  }"
                  @delete="handlerUploadDelete"
                  @uploadSuccess="handlerUploadSuccess" />
              </el-form-item>
            </div>
            <div class="form-item form-half">
              <span>Certificate of Incorporation/Business Registration Certificate</span>
              <el-form-item
                ref="id_type_pic_path_id"
                prop="id_type_pic_path_id">
                <v-upload
                  :card="true"
                  :fileData="formData.id_type_pic"
                  is-company
                  :file-list="fileList"
                  :otherData="{
                    target: 'id_type_pic',
                    idKey: 'id_type_pic_path_id',
                    nameKey: 'id_type_pic_path',
                    type:'id_type_pic_path'
                  }"
                  :disabled="isCancel||showBuyable"
                  @uploadSuccess="handlerUploadSuccess"
                  @delete="handlerUploadDelete"
                />
              </el-form-item>
            </div>
            <!--            <div class="form-item form-half">-->
            <!--              <span>Business Registration Certificate</span>-->
            <!--              <el-form-item-->
            <!--                ref="br_pic_path_id"-->
            <!--                prop="br_pic_path_id">-->
            <!--                <v-upload-->
            <!--                  :card="true"-->
            <!--                  :fileData="formData.br_pic"-->
            <!--                  :otherData="{-->
            <!--                    target: 'br_pic',-->
            <!--                    idKey: 'br_pic_path_id',-->
            <!--                    nameKey: 'br_pic_path'-->
            <!--                  }"-->
            <!--                  :disabled="isCancel||showBuyable"-->
            <!--                  @uploadSuccess="handlerUploadSuccess"-->
            <!--                  @delete="handlerUploadDelete"-->
            <!--                />-->
            <!--              </el-form-item>-->
            <!--            </div>-->

          </div>
          <div class="flex-sb">
            <div class="form-item form-half">
              <span>Contract</span>
              <el-form-item
                ref="contract_path_id"
                prop="contract_path_id">
                <v-upload
                  :card="true"
                  :fileData="formData.contract"
                  :file-list="fileList"
                  :otherData="{
                    target: 'contract',
                    idKey: 'contract_path_id',
                    nameKey: 'contract_path',
                    type:'contract_path'
                  }"
                  :disabled="isCancel||showBuyable"
                  @uploadSuccess="handlerUploadSuccess"
                  @delete="handlerUploadDelete"
                />
              </el-form-item>
            </div>
          </div>
          <!-- <div
          v-if="formData.cust_typ == 2"
          class="form-item form-half">
          <span>Certificate of Incorporation</span>
          <el-form-item
            ref="cert_of_inc_pic_path_id"
            prop="cert_of_inc_pic_path_id">
            <v-upload
              :card="true"
              :fileData="formData.cert_of_inc_pic"
              :otherData="{
                target: 'cert_of_inc_pic',
                idKey: 'cert_of_inc_pic_path_id',
                nameKey: 'cert_of_inc_pic_path'
              }"
              :disabled="isCancel"
              @uploadSuccess="handlerUploadSuccess"
            />
          </el-form-item>
        </div> -->
          <div class="form-item">
            <span>Additional Documents</span>
            <file-container
              v-for="(item, index) in formData.other_file"
              :key="index"
              :fileData="item"
              :file-list="fileList"
              :otherData="{
                index,
                type: 'other_file'
              }"
              :edit="true"
              :disabled="isCancel||showBuyable"
              titleName= "Additional Documents"
              @delete="handlerDeleteFile"
              @uploadSuccess="handlerUploadSuccess"
            />
            <v-upload
              :file-list="fileList"
              :otherData="{
                type: 'other_file',
              }"
              :disabled="isCancel||showBuyable"
              @uploadSuccess="handlerUploadSuccess" />
          </div>
        </div>

      </el-form>
    </lazy-dom>
  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import MixinRules from '@/mixins/rules'
import AddressForm from '@/views/components/address-form'
import DecorationPolicyHolderForm from '@/views/components/modules/decoration/decoration-policy-holder-form'
import dayjs from 'dayjs'
import MixinSame from '@/mixins/same'

export default {
  name: 'DecorationPolicyForm',
  components: {
    AddressForm,
    DecorationPolicyHolderForm
  },
  mixins: [MixinOptions, MixinFormat, MixinRules,MixinSame],
  props: {
    form: {
      type: Object,
      default: null
    },
    isCancel: {
      type: Boolean,
      default: false
    },
    isAdjust: {
      type: Boolean,
      default: false
    },
    editType:{
      type:Number,
      default:0
    },
    checkRefer:{
      type:Number,
      default:0
    },
    isEndorsement: {
      type: Boolean,
      default: false
    },
    showBuyable: {
      type: Boolean,
      default: false
    },
    isRefer: {
      type: Boolean,//refer case 显示insured item 全部选项
      default: false
    },
    editQuote:{
      type: Boolean,
      default: false
    }
  },
  data() {
    const checkOutdoor = (rule, value, callback) => {
      const valueResult = value !== null && value !== ''
      const { outdoor_wk_ind } = this.formData
      if(outdoor_wk_ind == 1 && !valueResult) {
        callback(new Error(this.$t('placeholder.input')))
      }
      callback()
    }
    const checkLimit = (rule, value, callback) => {
      const valueResult = value !== null && value !== ''
      const { tp_lia_cvr_ind } = this.formData
      if(tp_lia_cvr_ind == 1 && !valueResult) {
        callback(new Error(this.$t('placeholder.input')))
      }
      callback()
    }
    return {
      pickerOptions: {
        disabledDate(time){
          return time.getTime()<Date.now()
        }
      },
      formData: {
        updDefInfo: [],
        disable_filed: [],
        class_id: '',
        pcy_cmnt_dt: '',
        contr_prd: '',
        bldg_age: '',
        tol_contr_sum: '',
        tp_lia_cvr_ind: '',
        tppd_limit_amt: '',
        outdoor_wk_ind: '',
        scaffolding_wk: 0,
        employee_ind: '',
        pcy_expry_dt: '',
        work_addr_room: '',
        work_addr_floor: '',
        work_addr_block: '',
        work_addr_building: '',
        work_addr_street: '',
        work_addr_district: '',
        work_addr_area: '',
        work_addr_region: '',
        occupied_as: '',
        con_nm: '',
        con_phone_no: '',
        sub_contractors: '',
        property_management_company: '',
        con_addr_room: '',
        con_addr_floor: '',
        con_addr_block: '',
        con_addr_building: '',
        con_addr_street: '',
        con_addr_district: '',
        con_addr_area: '',
        con_addr_region: '',
        isrd_title: '',
        isrd_lst_nm: '',
        isrd_fst_nm: '',
        occ_id: '',
        id_no: '',
        mobile_no: '',
        email: '',
        addr_room: '',
        addr_floor: '',
        addr_block: '',
        addr_building: '',
        addr_street: '',
        addr_district: '',
        addr_area: '',
        addr_region: '',
        // 公司
        isrd_com_nm: '',
        // ci_no: '',
        phone_no: '',
        bsns_nature_id: '',
        contact_nm: '',
        contact_occ_id: '',
        contact_phone: '',
        contact_email: '',
        // file
        id_type_pic_path: '',
        id_type_pic_path_id: '',
        contract_path_id: '',
        contract_path: '',
        // cert_of_inc_pic_path: '',
        // cert_of_inc_pic_path_id: '',
        other_file: [],
        id_type_pic: {},
        contract: {},
        benefits:[],
        br_pic:null,
        br_pic_path_id: '',
        br_pic_path: '',        // cert_of_inc_pic: {}

        renewal_letter_insurer_path: '',
        renewal_letter_insurer_path_id: '',
        renewal_letter_insurer: {},
      },
      formDataLock: 0,
      subForm: {
        'policy-holder-form': false,
        'work-address-form': false,
        // 'con-address-form': false
      },
      otherData: {},
      workAddressData: {
        addr_room: '',
        addr_floor: '',
        addr_block: '',
        addr_building: '',
        addr_street: '',
        addr_district: '',
        addr_area: '',
        addr_region: ''
      },
      conAddressData: {
        addr_room: '',
        addr_floor: '',
        addr_block: '',
        addr_building: '',
        addr_street: '',
        addr_district: '',
        addr_area: '',
        addr_region: ''
      },
      formResult: {},
      extraRules: {
        tppd_limit_amt: [
          { validator: checkLimit, trigger: ['change', 'blur'] }
        ],
        outdoor_wk_sum: [
          { validator: checkOutdoor, trigger: ['change', 'blur'] }
        ]
      }
    }
  },
  computed: {
    localAllOptions() {
      return this.allOptions24
    },

    formRules() {
      let rulesOption = JSON.stringify(this.rules)
      rulesOption = JSON.parse(rulesOption)

      Object.keys(rulesOption).some(keys => {
        rulesOption[keys][0].required = false
      })


      Object.keys(this.ruleRequestData).some(key => {
        // Object.keys(rulesOption).some(keys => {
        //   if(key==keys)
        rulesOption[key][0].required = true
        // })
      })
      return this.checkRefer ===2 || this.editType == 3 ? this.rules : rulesOption
      // return this.rules
    },
    benefitList(){
      let {quote_coverage_list} =this.form||{}
      let {kyc_benefit=[]} = quote_coverage_list||{}
      let arr = []
      if(this.editQuote){
        arr = JSON.parse(JSON.stringify(this[`allOptions${this.formData.class_id}`].benefits))
      }else{
        kyc_benefit.some(item=>{
          // if(item.is_selected==1)
          //   this.formData.benefits.push(item.id)
          if(item.is_show!==0){
            arr.push({name:item.name,id:item.id})
          }
        })
      }
      return arr||[]
    },
    isFina(){
      let {merchant_platform} = this.form||{}
      return merchant_platform ==2
    }
  },
  watch: {
    form: {
      immediate: true,
      deep: true,
      handler(val) {

        if(val) {
          const formValue = JSON.parse(JSON.stringify(val))
          let form = JSON.parse(JSON.stringify(this.formData))
          Object.assign(
            form,
            formValue
          )
          if(val.id_type_pic) {
            const { path, id } = val.id_type_pic
            form.id_type_pic_path = path
            form.id_type_pic_path_id = id
          }
          if(val.contract) {
            const { path, id } = val.contract
            form.contract_path = path
            form.contract_path_id = id
          }
          if(val.br_pic) {
            const { path, id } = val.br_pic
            form.br_pic_path = path
            form.br_pic_path_id = id
          }
          // if(val.cert_of_inc_pic) {
          //   const { path, id } = val.cert_of_inc_pic
          //   form.cert_of_inc_pic_path = path
          //   form.cert_of_inc_pic_path_id = id
          // }
          // if(form.id_type == 2) {
          //   // form.id_type = 1
          //   form.id_no = ''
          // }
          this.formDataLock += 1
          this.formData = form
          let {quote_coverage_list} = val||{}
          let {kyc_benefit=[]} = quote_coverage_list||{}
          kyc_benefit.some(item=>{
            if(item.is_selected==1)
              this.formData.benefits.push(item.id)
          })
          this.formData.benefits= [...new Set( this.formData.benefits)]
          let date = new Date(this.formData.pcy_expry_dt).getTime()
          let dateCmnt = new Date(this.formData.pcy_cmnt_dt).getTime()

          if(date<Date.now())
          {
            this.formData.pcy_expry_dt =''
          }
          if(dateCmnt<Date.now() && this.editType != 3)
          {
            this.formData.pcy_cmnt_dt =''
          }
          if(this.isCancel)
          {
            // this.formData.pcy_expry_dt =''
          }

          // this.formData = JSON.parse(JSON.stringify(this.formData))
          this.handler().handlerAddress(this.formData)
        }
      }
    },
    'formData.pcy_cmnt_dt':{
      immediate:true,
      handler(val){
        let {pcy_period,ins_end_dt,pcy_expry_dt} = this.form
        if(pcy_period>0&&val)
          this.formData.pcy_expry_dt = dayjs(val).add(pcy_period,'month').subtract(1,'day').format('YYYY-MM-DD')
      }
    },
  },
  methods: {
    checkDisabled(field) {
      const { disable_filed = [] } = this.form
      if(typeof(field) != 'string'){
        let res = false
        field.map(item => {
          if(disable_filed.includes(item)){
            res = true
          }
        })
        return res
      }
      return disable_filed.includes(field)&&!!this.form[field]
    },
    handlerExtra(){
      let {extra_benefits,pcy_cmnt_dt,benefits} = this.formData
      let params = {
        extra_benefits,
        pcy_cmnt_dt,
        benefits
      }
      this.$emit('changeCompute',params)
    },
    submitForm(otherData = {}) {
      this.$refs['form'].validate((valid, rules) => {
        if(valid) {
          this.otherData = otherData
          Object.keys(this.subForm).some(key => {
            this.subForm[key] = false
            this.$refs[key].submitForm(key)
          })
          if(Object.values(this.subForm).some(item => item === false)) {
            return
          }

          const { scaffolding_wk, outdoor_wk_ind } = this.formData
          let {benefits=[]} = this.formData||{}
          const uniqueArray = benefits.filter((value, index, self) => {
            return self.indexOf(value) === index
          })
          const result = {
            ...this.formData,
            scaffolding_wk: outdoor_wk_ind? scaffolding_wk: 0,
            // 只能公司帳戶投保
            id_type: this.formData.cust_typ == 2? 3: 1,
            benefits:uniqueArray
          }
          this.formResult = result
          const { updDefInfo } = this.formData
          if(updDefInfo && updDefInfo.length > 0&&!this.isFina) {
            // if(this.formData.isUpdatePolicyData === 1) {
            this.$refs['policy-holder-form'].openConfirmDialog()
          }
          else {
            this.$emit('getFormData', result, otherData)
          }

        }
        else {
          this.scrollToValidDom(rules)
        }
      })

    },
    getSaveSubmitForm(otherData = {}){
      this.otherData = otherData
      Object.keys(this.subForm).some(key => {
        this.subForm[key] = false
        this.$refs[key].submitForm(key)
      })
      // if(Object.values(this.subForm).some(item => item === false)) {
      //   return
      // }
      let {benefits=[]} = this.formData||{}
      const uniqueArray = benefits.filter((value, index, self) => {
        return self.indexOf(value) === index
      })
      const result = {
        ...this.formData,
        // 只能公司帳戶投保
        id_type: this.formData.cust_typ == 2? 3: 1,
        benefits:uniqueArray
      }
      this.formResult = result
      const { updDefInfo } = this.formData
      if(updDefInfo && updDefInfo.length > 0) {
        // if(this.formData.isUpdatePolicyData === 1) {
        this.$refs['policy-holder-form'].openConfirmDialog()
      }
      else {
        this.$emit('getFormData', result, otherData)
      }

    },
    getConfirmChangeResult(result) {
      const params = this.formResult
      if(result) {
        params.upd_def_addr = 1 // 更新用戶資料
      }
      this.$emit('getFormData', params, this.otherData)
    },
    getSubFormData(formName, data) {
      this.subForm[formName] = true
      // 處理數據
      if(formName == 'policy-holder-form') {
        Object.assign(this.formData, data)
      }
      const {
        addr_room,
        addr_floor,
        addr_block,
        addr_building,
        addr_street,
        addr_district,
        addr_area,
        addr_region
      } = data
      if(formName == 'work-address-form') {
        Object.assign(this.formData, {
          work_addr_room: addr_room,
          work_addr_floor: addr_floor,
          work_addr_block: addr_block,
          work_addr_building: addr_building,
          work_addr_street: addr_street,
          work_addr_district: addr_district,
          work_addr_area: addr_area,
          work_addr_region: addr_region
        })
      }
      if(formName == 'con-address-form') {
        Object.assign(this.formData, {
          con_addr_room: addr_room,
          con_addr_floor: addr_floor,
          con_addr_block: addr_block,
          con_addr_building: addr_building,
          con_addr_street: addr_street,
          con_addr_district: addr_district,
          con_addr_area: addr_area,
          con_addr_region: addr_region
        })
      }
    },
    handlerUploadSuccess({ data, result, otherData }) {
      const { idKey, nameKey, target, index = '', type } = otherData
      const { id, path } = data
      if(type !== 'other_file') {
        this.$set(this.formData, idKey, id)
        this.$set(this.formData, nameKey, path)
        this.$set(this.formData, target, data)
        this.$refs['form'].validateField(idKey)
      }
      else {
        if(index === '') {
          this.formData.other_file.push(data)
        }
        else {
          this.$set(this.formData.other_file, index, data)
        }
      }
    },
    handlerUploadDelete({ otherData }) {
      const { idKey, nameKey, target, index = '', type } = otherData
      if(type !== 'other_file') {
        this.$set(this.formData, idKey, '')
        this.$set(this.formData, nameKey, '')
        this.$set(this.formData, target, null)
        this.$refs['form'].validateField(idKey)
      }
    },
    handlerDeleteFile(otherData) {
      const { type, index } = otherData
      if(type === 'other_file') {
        this.formData.other_file.splice(index, 1)
      }
    },
    handler() {
      return {
        handlerAddress: (data) => {
          const {
            con_addr_room,
            con_addr_floor,
            con_addr_block,
            con_addr_building,
            con_addr_street,
            con_addr_district,
            con_addr_area,
            con_addr_region,
            work_addr_room,
            work_addr_floor,
            work_addr_block,
            work_addr_building,
            work_addr_street,
            work_addr_district,
            work_addr_area,
            work_addr_region,
          } = data
          const con = {
            addr_room: con_addr_room,
            addr_floor: con_addr_floor,
            addr_block: con_addr_block,
            addr_building: con_addr_building,
            addr_street: con_addr_street,
            addr_district: con_addr_district,
            addr_area: con_addr_area,
            addr_region: con_addr_region,
          }
          const work = {
            addr_room: work_addr_room,
            addr_floor: work_addr_floor,
            addr_block: work_addr_block,
            addr_building: work_addr_building,
            addr_street: work_addr_street,
            addr_district: work_addr_district,
            addr_area: work_addr_area,
            addr_region: work_addr_region,
          }
          // const params = {}
          // Object.keys(this.addressForm).some(key => {
          //   params[key] = data[key]
          // })
          // this.formDataLock += 1
          // this.addressForm = JSON.parse(JSON.stringify(params))
          // this.corAddressForm = JSON.parse(JSON.stringify(obj))
          this.formDataLock += 1
          this.workAddressData = work
          this.conAddressData = con
        },
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.policy-form {
  .title {
    font-size: 20px;
    color: #616266;
    font-weight: 500;
  }
}
</style>
